export const DEFAULT_LEDGER = {
  name: 'ErisX',
  ledgerId: null,
  memberId: null,
};
